import { controls, currencyToNumber, grouped } from "../../controls";

const pacs_ots_bank = {
  label: "PACS OTS",
  starting: true,
  url: "pacs_ots_bank",
  pageLabel: "PACS OTS",
  pageType: "history",
  // filteraction: true,
  filter: [

    ...controls.displayText({ tab: "filter", label: "DCC Bank" }),
    ...controls.oc({ tab: "filter", length: 4, c: "Client", placeHolder: "Bank Code", name: "client_code", fastpath: "clients" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "client_display" }),

    ...controls.magicDateLabel({ tab: "filter", label: "As On Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", default: "lfe" }),

  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "PACS OTS",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    textReportProps: {
      'Recon': {
        filename: `PACS OTS-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },

    pivot: true,
    charts: {
      pie: {
        row: { targetfield: 'amount_pct', flabel: 'pacs_name' },
        column: { targetrow: 'grand_total' },
        // colors:[...Array(100).keys()].map(r=>chroma.random())
      }
    },
    extraRows: {
      location: "bottom",
      fields: ["count_defaulter_loanee_2019", "amount_defaulter_outstanding_2019", "count_recovery_overdue_2019", "amount_recovery_overdue_2019"],
      subtotals: {
        by: "client_display",
        displayIn: "pacs_name",
        count: true
      },
      grandtotal: { type: "fixed", displayIn: "pacs_name", val: "Grand Total", count: true },
    },
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "PACS", accessor: "pacs_name", rwidth: "*" },
      {
        Header: "Overdue on 31/08/2019",
        columns: [
          { Header: "Count", accessor: "count_defaulter_loanee_2019", type: "currency", align: "center" },
          { Header: "Amount", accessor: "amount_defaulter_outstanding_2019", type: "currency" },
        ]
      },
      {
        Header: "Repaid During 01/09/2019 - 31/01/2020",
        columns: [
          { Header: "Count", accessor: "count_recovery_overdue_2019", type: "currency", align: "center" },
          { Header: "Amount", accessor: "amount_recovery_overdue_2019", type: "currency" }
        ]
      },
      {
        Header: "% Recovery to Overdue",
        columns: [
          {
            Header: "Count %",
            accessor: "count_pct",
            width132: { size: 13, },
            formula: [{
              f: 'simpleArithmatic', calcType: 'pct', inputs: [
                { source: 'row', field: 'count_recovery_overdue_2019' },
                { source: 'row', field: 'count_defaulter_loanee_2019' },
              ], resultVar: 'total'
            }],
            align: "center"
          },

          {
            Header: "Amount %",
            accessor: "amount_pct",
            width132: { size: 13, },
            formula: [{
              f: 'simpleArithmatic', calcType: 'pct', inputs: [
                { source: 'row', field: 'amount_recovery_overdue_2019' },
                { source: 'row', field: 'amount_defaulter_outstanding_2019' },
              ], resultVar: 'total'
            }],
            align: "center"
          }
        ]
      }
    ]
  }
};

export default pacs_ots_bank;